import { Link } from 'react-router';
import { SquareArrowOutUpRight } from 'lucide-react';
import { InfoTip, type SettingsColumnHead } from '@/modules/settings';

/** The Active table's column titles, rendered in the page's sticky header. */
export const ACTIVE_INTENT_COLUMNS: SettingsColumnHead[] = [
	{ id: 'name', header: 'Name' },
	{
		id: 'skip',
		className: 'w-[219px] justify-center',
		header: (
			<>
				Skip Pre-Processing
				<Link
					to='/settings/handling?tab=pre-processing'
					aria-label='Open pre-processing settings'
					className='flex size-6 shrink-0 items-center justify-center rounded-full text-gray-800 hover:bg-gray-100'
				>
					<SquareArrowOutUpRight className='size-3.5' />
				</Link>
				<InfoTip label='About skipping pre-processing'>
					Decide whether the pre-processing step is bypassed for an intent: no tags are changed and the ticket is not assigned to
					Kim.
				</InfoTip>
			</>
		)
	},
	{
		id: 'process',
		className: 'w-[150px] justify-center',
		header: (
			<>
				Process Intent
				<Link
					to='/settings/ingestion?tab=intents'
					aria-label='Open intent filtering in Ingestion'
					className='flex size-6 shrink-0 items-center justify-center rounded-full text-gray-800 hover:bg-gray-100'
				>
					<SquareArrowOutUpRight className='size-3.5' />
				</Link>
				<InfoTip label='About processing an intent'>
					After ingestion, decide whether a query should be processed and a response generated for it. Applies while
					intent-based filtering is on (Ingestion › Intents).
				</InfoTip>
			</>
		)
	},
	{
		id: 'auto',
		className: 'w-[150px] justify-center',
		header: (
			<>
				Auto-send
				<InfoTip label='About auto-send'>Decide whether a query falling in an intent is automated or not.</InfoTip>
			</>
		)
	},
	{
		id: 'checks',
		className: 'w-[120px] justify-center',
		header: (
			<>
				Checks
				<InfoTip label='About automation checks'>The tools and sources every reply Kim sends on its own for an intent must use.</InfoTip>
			</>
		)
	},
	{
		id: 'spam',
		className: 'w-[150px] justify-center',
		header: (
			<>
				Mark as spam
				<InfoTip label='About marking as spam'>
					Tickets with a spam intent are marked as spam, 24x7, and can also be auto-closed (from the menu beside the checkbox).
				</InfoTip>
			</>
		)
	}
];
